import * as React from 'react';

function SvgSend(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.004 13.942l6.56-6.597L8.7 13.057l6.304.885zm9.504-9.545L5.696 12.75c-.69.306-.547 1.324.2 1.429l8.687 1.219 1.22 8.688c.104.746 1.122.889 1.428.2l8.422-18.968a.739.739 0 00-.17-.85.75.75 0 00-.975-.07zm-1.855 3.98l-6.608 6.646.879 6.258 5.73-12.904z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgSend;
